import { render, staticRenderFns } from "./ProfileStatistic.vue?vue&type=template&id=0387d694&"
import script from "./ProfileStatistic.vue?vue&type=script&lang=ts&"
export * from "./ProfileStatistic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports